import { fetchEmployerData } from './employerData';

// SEC-003.1: no Sanity token in the browser any more. Same call shape as before:
// client.fetch(request) with a request from utils/Data.js.
export const client = { fetch: fetchEmployerData };
